function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logout"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2130",
  "data-name": "Rectangle 2130",
  width: 24.981,
  height: 24.98,
  fill: "#505e6c",
  stroke: "#505e6c",
  strokeWidth: 0.2
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11984",
  "data-name": "Group 11984",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1557",
  "data-name": "Path 1557",
  d: "M288.6,133.135l.008-.011c.013-.016.025-.032.036-.049s.013-.022.02-.032.013-.021.019-.032.014-.029.021-.044l.011-.024c.007-.018.014-.036.02-.054l.006-.016c.007-.023.013-.047.018-.071v0a.78.78,0,0,0-.212-.711l-3.9-3.9a.781.781,0,0,0-1.1,1.1l2.572,2.572H278.1a.781.781,0,0,0,0,1.561h8l-2.57,2.57a.781.781,0,1,0,1.1,1.1l3.9-3.9a.794.794,0,0,0,.059-.065",
  transform: "translate(-263.792 -121.714)",
  fill: "#505e6c",
  stroke: "#505e6c",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1558",
  "data-name": "Path 1558",
  d: "M15.873,13.531a.781.781,0,0,0-.781.781V19a1.3,1.3,0,0,1-1.3,1.3H10.408V4.163a2.1,2.1,0,0,0-1.418-1.98L7.123,1.561h6.669a1.3,1.3,0,0,1,1.3,1.3V7.546a.781.781,0,1,0,1.561,0V2.862A2.865,2.865,0,0,0,13.791,0H2.082A2.084,2.084,0,0,0,0,2.082V20.817A2.1,2.1,0,0,0,1.418,22.8l6.264,2.087a2.146,2.146,0,0,0,.645.1A2.084,2.084,0,0,0,10.408,22.9V21.858h3.383A2.865,2.865,0,0,0,16.653,19V14.312a.781.781,0,0,0-.781-.781M8.847,22.9a.522.522,0,0,1-.52.521.565.565,0,0,1-.17-.023L1.922,21.319a.541.541,0,0,1-.361-.5V2.082a.522.522,0,0,1,.52-.521.566.566,0,0,1,.17.023L8.486,3.662a.541.541,0,0,1,.361.5Z",
  transform: "translate(0 0)",
  fill: "#505e6c",
  stroke: "#505e6c",
  strokeWidth: 0.2
}));

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11985",
    "data-name": "Group 11985",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.981,
    height: 24.98,
    viewBox: "0 0 24.981 24.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8fbfb6ed.svg";
export { ForwardRef as ReactComponent };